
export const getTagColor = (status: string) => {
    if (status.toLowerCase() === 'active' || status.toLowerCase() === 'delivered' || status.toLowerCase() === 'finished' || status.toLowerCase() === 'passed') return 'success'
    if(status.toLowerCase() === 'pending') return 'warning'
    if (status.toLowerCase() === 'inactive' || status.toLowerCase() === 'greig' || status.toLowerCase() === 'removed' || status.toLowerCase() === 'unfinished' || status.toLowerCase() === 'failed' || status.toLowerCase() === 'quarantine' || status.toLowerCase() === 'cancelled') return 'danger'
    if (status.toLowerCase() === 'available' || status.toLowerCase() === 'shipped') return 'info'
    if (status.toLowerCase() === 'dispatched') return 'secondary'
    if (status.toLowerCase() === 'offsite') return 'warning'
    return ''
}

export const getToastIcon = (toastClass: string[]) => {
    if (toastClass.includes('success')) return 'akar-icons:check-box-fill'
    if (toastClass.includes('info')) return 'solar:info-square-bold'
    if (toastClass.includes('error')) return 'bxs:error'
    return ''
}

export const getCustomerStatusColor = (status: string) => {
    if (status.toLowerCase() === 'active') return 'success'
    if (status.toLowerCase() === 'inactive') return 'danger'
    return ''
}

export const convertErrorsToVeeValidateFormat = (errors: any) => {
    const veeValidateErrors = {} as any

    errors.forEach((error: any) => {
        const path = error.path
            .map((segment: any) => {
                // Convert array indices to square bracket format
                return Number.isInteger(segment) ? `[${segment}].` : segment
            })
            .join('') // Join path segments into a string

        veeValidateErrors[path] = error.message
    })

    return veeValidateErrors
}
